export default __webpack_public_path__ + "static/jewellery-app-ec2afbabcd2774033166e778e1e94d84.png";